import { Checkbox } from '@nike/eds';
import { useI18nContext } from '../../../../context/language/use-i18n-context';
import { FC, useState, useEffect } from 'react';
import { ts } from '../i18n';

export interface Props {
  onComplianceChange: (checked: boolean) => void;
  policyLocationId: number;
  isChecked: boolean;
}
export const GovtCompliance: FC<Props> = ({
  onComplianceChange,
  policyLocationId,
  isChecked = false,
}) => {
  const { i18nString } = useI18nContext();
  const [checked, setChecked] = useState(isChecked);

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  const handleCheckboxChange = () => {
    setChecked(!checked);
    onComplianceChange(!checked);
  };

  return (
    <>
      <div className="modal__panel">
        <div>
          <Checkbox
            className={'eds-spacing--mr-12 eds-spacing--mt-6 checkbox_compl'}
            id="govtCompliance"
            name="govtCompliance"
            hideLabel={true}
            label="Government Complinace"
            aria-label="Government Complinace Checkbox"
            checked={checked}
            onClick={handleCheckboxChange}
          />
          {policyLocationId === 344 && (
            <span
              className="txt_compliance"
              dangerouslySetInnerHTML={{ __html: i18nString(ts.GOVT_COMPLIANCE_HONGKONG) }}
            ></span>
          )}
          {policyLocationId === 158 && (
            <span
              className="txt_compliance"
              dangerouslySetInnerHTML={{ __html: i18nString(ts.GOVT_COMPLIANCE_TAIWAN) }}
            ></span>
          )}
          {policyLocationId === 156 && (
            <span
              className="txt_compliance"
              dangerouslySetInnerHTML={{ __html: i18nString(ts.GOVT_COMPLIANCE_CHINA) }}
            ></span>
          )}
        </div>
        <div className="cb"></div>
      </div>
    </>
  );
};
